import { writable } from 'svelte/store';

export const mode = writable("start");
export const provetta = writable(null);
export const location = writable(null);
export const email = writable(null);
export const pushRegistration = writable(null);
export const timestamp = writable(null);
export const height = writable(null);
export const note = writable(null);